import { render, staticRenderFns } from "./Params.vue?vue&type=template&id=536ec370&scoped=true"
import script from "./Params.vue?vue&type=script&lang=js"
export * from "./Params.vue?vue&type=script&lang=js"
import style0 from "./Params.vue?vue&type=style&index=0&id=536ec370&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536ec370",
  null
  
)

export default component.exports